import Plyr from 'plyr';

const video = (widget = null) => {

  let videos;

  if (widget) {
    videos = document.querySelectorAll(`${widget} .u-plyr`)
  } else {
    videos = document.querySelectorAll('.u-plyr')
  }

  if (videos) {
    Array.from(videos).forEach((el) => {

      const { plyrFakeId } = el.dataset
      const consentTrigger = document.querySelector(`button[data-target="video-${plyrFakeId}"]`);

      const player = new Plyr(el, {
        loadSprite: false,
        iconPrefix: 'cplyr',
        controls: [
          'play-large',
          'play',
          'pause',
          'progress',
          'current-time',
          'mute',
          'volume',
          'fullscreen',
        ],
      });

      if (consentTrigger) {
        consentTrigger.addEventListener('click', () => {
          consentTrigger.parentNode.parentNode.parentNode.classList.add('has-started')
          player.play()
        })
      }
    })
  }
};
video();
window.video = video
